// `/distributors/$id/users` — таб «Сотрудники» в карточке тенанта для
// PLATFORM_ADMIN (PA-12, D17 §2.3).
//
// View-only: PA смотрит список сотрудников тенанта, не управляет. Backend
// gate'ит permission `platform.distributors.view`. Layout-route
// `distributors.$id.tsx` отвечает за `AdminShell`, breadcrumb, TabBar и
// `redirectIfNotPlatformAdmin` (наследуется child'ом через TanStack Router
// `beforeLoad`).

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { DistributorUsersTabScreen } from '../features/distributors/tabs/DistributorUsersTabScreen'

export const Route = createFileRoute('/distributors/$id/users')({
  component: DistributorUsersTab,
})

function DistributorUsersTab() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    return (
      <RequireAuth>
        <div style={{ padding: 24, color: 'var(--color-text-secondary)' }}>
          Некорректный идентификатор дистрибьютора в URL.
        </div>
      </RequireAuth>
    )
  }
  return (
    <RequireAuth>
      <DistributorUsersTabScreen distributorId={numericId} />
    </RequireAuth>
  )
}
